import { setContext } from 'svelte';
import type { LiveDropInfoResponse } from '../../../types';
import { Contexts } from '#lib/constants/contexts.js';

export interface LiveDropInfoContextState {
	liveDropInfo: LiveDropInfoResponse | null;
	liveDropInfoLoading: boolean;
	setLiveDropInfo: (newLiveDropInfo: LiveDropInfoResponse | null) => void;
	setLoading: (loading: boolean) => void;
}

export function createLiveDropInfoContext() {
	let liveDropInfo = $state<LiveDropInfoResponse | null>(null);
	let liveDropInfoLoading = $state(true);

	const liveDropInfoCtx: LiveDropInfoContextState = {
		get liveDropInfo() {
			return liveDropInfo;
		},
		get liveDropInfoLoading() {
			return liveDropInfoLoading;
		},
		setLiveDropInfo: (newLiveDropInfo: LiveDropInfoResponse | null) => {
			liveDropInfo = newLiveDropInfo;
		},
		setLoading: (loading: boolean) => {
			liveDropInfoLoading = loading;
		},
	};

	setContext(Contexts.LiveDropInfo, { liveDropInfoCtx });
}
